import { CanUpdateTripOutput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useState } from 'react';

import { UpdateAnonymousTripAddress } from './UpdateAnonymousTripAddress';
import { UpdateAnonymousTripDepartureAt } from './UpdateAnonymousTripDepartureAt';
import { t } from '../../../../services/translation/translation';
import { SecondaryButton } from '../../../button/SecondaryButton';
import { Modal } from '../../../Modal';
import { Spinner } from '../../../Spinner';
import { UpdateTripChoice } from '../UpdateTripChoice';

type Props = {
  trip: TripOutput;
  onClose: () => void;
  jwtToken: string;
  data: CanUpdateTripOutput | undefined;
  isLoading: boolean;
};

export const UpdateAnonymousTripModal = ({ trip, onClose, jwtToken, data, isLoading }: Props) => {
  const [step, setStep] = useState<'pick' | 'changeDepartureAt' | 'changeStartAddress' | 'changeEndAddress'>('pick');

  const handleValue = (value: 'changeDepartureAt' | 'changeStartAddress' | 'changeEndAddress') => {
    setStep(value);
  };

  const isUnauthorized =
    data?.canUpdateDepartureAt === false && data.canUpdateStartAddress === false && data.canUpdateEndAddress === false;

  return (
    <Modal onClose={onClose}>
      {isLoading ? (
        <Spinner />
      ) : step === 'pick' ? (
        isUnauthorized ? (
          <div className="flex flex-col p-3 gap-3">
            {t('update-trip.modal.warning.cant-update')}
            <SecondaryButton onClick={() => onClose()}>Retour</SecondaryButton>
          </div>
        ) : (
          <UpdateTripChoice onValidate={handleValue} data={data} tripFlash={trip.tripVars.flash} />
        )
      ) : step === 'changeDepartureAt' ? (
        <UpdateAnonymousTripDepartureAt
          onClose={onClose}
          trip={trip}
          jwtToken={jwtToken}
          initialDate={trip.resume.departureAt}
        />
      ) : step === 'changeStartAddress' || step === 'changeEndAddress' ? (
        <UpdateAnonymousTripAddress onClose={onClose} jwtToken={jwtToken} trip={trip} period={step} />
      ) : null}
    </Modal>
  );
};
